import { foodCostColor } from "../lib/constants";

/**
 * Semaforo food-cost: un pallino colorato verde/giallo/rosso (o grigio se senza prezzo).
 * Usato accanto al nome dei piatti nelle liste.
 */
export function TrafficLight({ pct, hasPrice = true, size = 12, title }) {
    const color = hasPrice && pct > 0 ? foodCostColor(pct) : "#9e9e9e";
    const label =
        !hasPrice || !pct || pct <= 0
            ? "Senza prezzo"
            : pct < 30
                ? "Ottimo"
                : pct < 35
                    ? "Attenzione"
                    : "Critico";
    return (
        <span
            data-testid="traffic-light"
            title={title || `Food cost: ${label}`}
            aria-label={`Semaforo food cost: ${label}`}
            className="inline-block rounded-full shrink-0"
            style={{
                width: size,
                height: size,
                background: color,
                boxShadow: `0 0 0 2px ${color}22, 0 0 10px ${color}55`,
            }}
        />
    );
}
